/*
 * Copyright (c) 2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from 'react'
import clsx from 'clsx'
import {useTranslation} from 'react-i18next'
import {FunnelIcon} from '@heroicons/react/24/outline'
import UiButton, {UiButtonSize, UiButtonStyle} from 'components/Ui/UiButton'

interface UiTableHeaderFiltersToggleButtonTableApi {
    columnFiltersVisible?: boolean
    setColumnFiltersVisible?: (visible: boolean) => void
    toggleColumnFiltersVisible?: () => void
}

interface UiTableHeaderFiltersToggleButtonProps {
    tableInit: UiTableHeaderFiltersToggleButtonTableApi
}

const UiTableHeaderFiltersToggleButton: React.FC<UiTableHeaderFiltersToggleButtonProps> = ({
    tableInit,
}) => {
    const { t } = useTranslation()
    const filtersVisible = tableInit.columnFiltersVisible ?? false

    const handleClick = () => {
        if (typeof tableInit.toggleColumnFiltersVisible === 'function') {
            tableInit.toggleColumnFiltersVisible()
            return
        }

        tableInit.setColumnFiltersVisible?.(!filtersVisible)
    }

	//disabled temporarily
	return (
		<></>
	)
    return (
        <UiButton
            className={clsx('UiTableHeaderFiltersToggleButton')}
            size={UiButtonSize.Normal}
            style={filtersVisible ? UiButtonStyle.Primary : UiButtonStyle.Secondary}
            title={
                filtersVisible
                    ? (t('Filters: ON') as string)
                    : (t('Filters: OFF') as string)
            }
            onClick={handleClick}
            icon={<FunnelIcon className="w-5 h-5" />}
        />
    )
}

export default UiTableHeaderFiltersToggleButton
